export default function({ state, commit, dispatch }, message) {
    commit('startMessagingPatientBulk')

    return dispatch('post', {
        url: '/provider/' + state.id + '/message',
        data: message
    }, {
        root: true
    })
    .then((response) => {
        commit('finishMessagingPatientBulk')
        
        return response
    })
    .catch((error) => {
        commit('finishMessagingPatientBulk')
        throw error
    })
}
